import format from 'date-fns/format'
export const toYYYYMMDD = (date) => format(date, 'yyyy-MM-dd')
export const currentYYYYMMDD = () => toYYYYMMDD(new Date())
